export const getRecaptchaToken = () => {
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    return new Promise((resolve) => {
        if (window.grecaptcha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(siteKey).then((token) => {
                    resolve(token);
                });
            });
        } else {
            console.warn("reCAPTCHA not loaded");
            resolve(null);
        }
    });
};
